export default __webpack_public_path__ + "static/media/fp.bf909757.jpeg";